import { AppointmentTypeContainer } from '../../features/master-data/appointment-type/AppointmentTypeContainer';
import {
  compose,
  withAuthorized,
  withBaseLayout,
  withHelmet
} from '../../core';

export const MasterDataAppointmentType = compose(
  withAuthorized,
  withBaseLayout,
  withHelmet({
    title: 'Splashworks: Appointment Types'
  })
)(AppointmentTypeContainer);
